module.exports = __webpack_public_path__ + "static/media/giphy2.d86375b4.gif";